<template lang="pug">
nav.navbar.app-navbar.animated(:class='{ slideInDown: show, slideOutDown: !show }')
  .navbar-brand
    a.hero-brand.navbar-item(href='/')
      img(src='~assets/icon.png')
      span.is-hidden-mobile
        span.co-name Triseum
        strong.admin Admin
    .navbar-burger(class="{'is-active': sidebar.opened}" @click='toggleSidebar({opened: !sidebar.opened})')
      span
      span
      span
  .navbar-menu.navbar-end
    .navbar-item.has-dropdown.is-hoverable
      router-link.navbar-link(to='/settings')
        span.icon
          i.fa.fa-cog
        | Settings
      .navbar-dropdown.is-right
        .navbar-item
          b Endpoints
        a.navbar-item(v-for='opt in api.options' @click='setEndpoint' :data-value='opt.name') {{ opt.name }}
        hr.navbar-divider
        .navbar-item Version: {{ pkginfo.version }}
    router-link.navbar-item(v-if='!auth' to='/login')
      span.icon
        i.fa.fa-key
      |  Login
    a.navbar-item(v-if='auth' @click='logout')
      span.icon
        i.fa.fa-lock
      |  Logout
</template>

<script>
import Tooltip from '../Tooltip'
import { mapActions } from 'vuex'
import { UPDATE_ENDPOINT } from 'vuex-store/mutation-types'

export default {
  components: {
    Tooltip
  },

  props: {
    show: Boolean
  },

  computed: {
    sidebar () {
      return this.$store.state.app.sidebar
    },
    api () {
      return {
        options: this.$store.state.endpointOptions
      }
    },
    pkginfo () {
      return this.$store.state.pkg
    },
    auth () {
      return this.$store.getters['auth/ok']
    }
  },
  methods: {
    logout () {
      // delete login
      this.$store.dispatch('auth/logout')
      this.$router.push('Home')
    },
    setEndpoint (event) {
      let selectedObject = this.api.options.find((i) => {
        return i.name === event.target.getAttribute('data-value')
      })
      this.$store.commit(UPDATE_ENDPOINT, selectedObject.name)
      if (!this.$store.getters['auth/ok']) {
        this.logout()
      }
    },
    ...mapActions([
      'toggleSidebar'
    ])
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/initial-variables';
@import '~bulma/sass/utilities/derived-variables';

.app-navbar {
  z-index: 10;
  box-shadow: 0 1px 1px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
}

.hero-brand {
  img {
    height: $size-medium;
    bottom: -5px;
  }
  .co-name {
    color: #DCC691;
  }
  .admin {
    color: #3A261A;
  }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?03316cb8